import React, { Component } from 'react';

class Cities extends Component {

  render() {
    const { data } = this.props;

    return data ? (
      <ul>
        { Object.keys( data ).map( (item, idx) => <li key={ idx }> <a href={ data[item] }> { item } </a> </li> ) }
      </ul>
    ) : null;
  }
}

export default Cities;
